import { API_URL } from "@/shared/config";

export const MESSAGING_REST_PATH = "/messaging/crudMessage";
export const MESSAGING_CONVERSATION_PATH = "/messaging/crudConversation";
export const MESSAGING_MESSAGE_READ_PATH = "/messaging/messageRead";

export const MESSAGING_ENDPOINTS = {
  CRUD_CONVERSATION: (buildingPk: number | string) =>
    `${MESSAGING_CONVERSATION_PATH}/${buildingPk}/`,
  CRUD_MESSAGE: (buildingPk: number | string) =>
    `${MESSAGING_REST_PATH}/${buildingPk}/`,
  MESSAGE_READ: (buildingPk: number | string) =>
    `${MESSAGING_MESSAGE_READ_PATH}/${buildingPk}/`,
} as const;

export const MESSAGING_WS_PATH = "/ws/messaging/";

/** Port Daphne par défaut en dev local (HTTP Django = 8000). */
const DAPHNE_PORT = "8001";

/**
 * Joint l'origine WS et le chemin sans dupliquer le segment `/ws`.
 */
function joinWsOriginAndPath(origin: string, path: string): string {
  const base = origin.endsWith("/") ? origin.slice(0, -1) : origin;
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  if (base.endsWith("/ws") && normalizedPath.startsWith("/ws/")) {
    return `${base}${normalizedPath.slice(3)}`;
  }
  return `${base}${normalizedPath}`;
}

function resolveWsOrigin(): string {
  const explicit = (import.meta.env.VITE_MESSAGING_WS_URL as string | undefined)?.replace(
    /\/$/,
    "",
  );
  if (explicit) return explicit;

  if (import.meta.env.DEV && typeof window !== "undefined") {
    const proto = window.location.protocol === "https:" ? "wss:" : "ws:";
    // Proxy Vite (vite.config.ts) → Daphne :8001, même origine que la page.
    return `${proto}//${window.location.host}`;
  }

  return API_URL.replace(/^http/, "ws")
    .replace(":8000", `:${DAPHNE_PORT}`)
    .replace(/\/$/, "");
}

export const MESSAGING_WS_ORIGIN = resolveWsOrigin();

export const MESSAGING_EVENTS = {
  CONNECTION_INIT: "connectionInit",
  CONNECTION_DISCONNECT: "connectionDisconnect",
  MESSAGE_SENT: "messageSent",
  MESSAGE_RECEIVE: "messageReceive",
  PING: "ping",
  PONG: "pong",
  ERROR: "error",
} as const;

export type MessagingEventName =
  (typeof MESSAGING_EVENTS)[keyof typeof MESSAGING_EVENTS];

export interface MessagingWsEnvelope<T = Record<string, unknown>> {
  event: MessagingEventName | string;
  payload: T;
}

export function buildMessagingWsUrl(token: string): string {
  const params = new URLSearchParams({ token });
  return `${joinWsOriginAndPath(MESSAGING_WS_ORIGIN, MESSAGING_WS_PATH)}?${params.toString()}`;
}
